import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { goalDescriptionAtom } from "lib/atoms";
import { useAtom } from "lib/global-context";
import styles from "./goal-select.module.css";

interface GoalSelectProps {
  config: {
    displayConfiguration: {
      title: string;
      choices?: {
        id: string;
        value: string;
      }[];
      placeholder?: string;
    };
  };
}

const GoalSelect = ({ config }: GoalSelectProps) => {
  const { displayConfiguration } = config;
  const { title, choices, placeholder } = displayConfiguration;
  const [goal, setGoal] = useAtom(goalDescriptionAtom);

  const currentGoalDescription =
    goal === "others"
      ? "Others"
      : choices?.find((g) => g.value === goal)?.value || "";

  return (
    <div className={styles.container}>
      <label htmlFor="goal" className={styles.label}>
        {title}
      </label>

      <Select
        value={goal || ""}
        onValueChange={(value) => setGoal(value)}
        placeholder={placeholder}
      >
        <SelectTrigger id="goal">
          <SelectValue>{currentGoalDescription}</SelectValue>
        </SelectTrigger>

        <SelectContent>
          {choices?.map((choice) => (
            <SelectItem key={choice.id} value={choice.value}>
              {choice.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default GoalSelect;
